<template>
  <li class="m-breadcrumb-item">
    <router-link :to="to" v-if="!!to">
      <span class="m-breadcrumb--link"><slot></slot></span>
    </router-link>
    <span v-else class="m-breadcrumb--text"><slot></slot></span>
    <span class="m-breadcrumb--separator">{{separator}}</span>
  </li>
</template>
<script>
export default {
  name: 'm-breadcrumb-item',
  props: {
    to: [Object, String]
  },
  computed: {
    separator () {
      return this.$parent.separator
    }
  }
}
</script>
